import { Templates } from "./Templates";
import { scoreMessage } from "./templates/scoreMessageTemplates";

export class ScoreMessageBox {
	constructor(points:number){
		this._displayScore(points);
	}
	
	private _displayScore(points:number):void {
		let msgBox = Templates.createDiv(scoreMessage);
		
		let msgDiv = msgBox.querySelector(".scoreMes-message");
		msgDiv.innerHTML = `You earned ${points} points for your team!`;
		document.querySelector("body").append(msgBox);
		
		window.setTimeout(() => {
			msgBox.classList.add("scoreMes-fade");
			window.setTimeout(() => {
				msgBox.remove();
				msgBox = null;
			}, 500);
		}, 2000);
	}
}